import { useCallback } from "react";
import { createGlobalState, useEffectOnce, useInterval } from "react-use";
import api from "../../services/api";

const useGlobalData = createGlobalState({});
const useGlobalLoading = createGlobalState(true);
const useGlobalFetching = createGlobalState(false);

export default function useOverview() {
  const [overview, setOverview] = useGlobalData();
  const [loading, setLoading] = useGlobalLoading();
  const [isFetching, setIsFetching] = useGlobalFetching();

  const fetchOverview = useCallback(async () => {
    if (isFetching) {
      return;
    }

    setIsFetching(true);

    try {
      // Fetch overview from the backend REST API
      const { result, error } = await api.fetch("/overview");

      if (!error && result) {
        setOverview(result);
        setLoading(false);
      } else {
        console.error("Error fetching overview:", error);
        // Fallback data if API fails
        setOverview({
          latestHeight: 0,
          finalizedHeight: 0,
          signedExtrinsics: 0,
          transfers: 0,
          accounts: 0,
        });
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching overview:", error);
      setOverview({
        latestHeight: 0,
        finalizedHeight: 0,
        signedExtrinsics: 0,
        transfers: 0,
        accounts: 0,
      });
      setLoading(false);
    } finally {
      setIsFetching(false);
    }
  }, [isFetching, setOverview, setIsFetching, setLoading]);

  useEffectOnce(fetchOverview);

  useInterval(() => {
    fetchOverview();
  }, 6000); // Refresh every 6 seconds to match backend update interval

  return { overview, loading };
}
